import { styled, Box, Typography, TextField } from "@mui/material";
import { SecondaryActionButton } from "..";

export const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  width: "100%",
});

export const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
  width: "100%",
}));

export const SignTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: "16px",
  color: theme.palette.text.secondary,
  flex: 1,
}));

export const ButtonContainer = styled(Box)<{ isMobile: boolean }>(
  ({ isMobile }) => ({
    display: "flex",
    justifyContent: "flex-end",
    ...(isMobile && { order: 2, marginTop: "8px" }),
  }),
);

export const SignatureWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  marginBottom: "16px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "stretch",
    flexWrap: "nowrap",
  },
}));

export const SignatureCanvasContainer = styled(Box)<{ isMobile: boolean }>(
  ({ isMobile }) => ({
    border: "1px solid #EAEAEA",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "280px",
    padding: "4px",
    width: "100%",
    ...(isMobile && { order: 1 }),
  }),
);

export const SignatureImg = styled("img")({
  width: "50%",
  height: "50%",
});

export const CleanSignButton = styled(SecondaryActionButton)({
  fontSize: "14px",
  width: "fit-content",
  padding: "8px",
});

export const ErrorMessage = styled(Typography)<{ isMobile: boolean }>(
  ({ theme, isMobile }) => ({
    color: theme.palette.error.main,
    fontSize: "12px",
    paddingTop: "4px",
    ...(isMobile && { order: 3 }),
  }),
);

export const StampWrapper = styled(Box)<{ hasStamp: boolean }>(
  ({ hasStamp }) => ({
    marginTop: "16px",
    ...(hasStamp === false && {
      backgroundColor: "#ffffff",
      padding: "16px",
      borderRadius: "8px",
      border: "1px solid #EAEAEA",
    }),
  }),
);

export const StampHeader = styled(Box)<{
  isMobile: boolean;
  hasStamp: boolean;
}>(({ isMobile, hasStamp }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: "16px",
  alignItems: "center",
  ...(isMobile &&
    !hasStamp && {
      flexDirection: "column",
      alignItems: "stretch",
    }),
}));

export const StampLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: "16px",
  color: theme.palette.text.secondary,
  margin: "8px 0",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
}));

export const StampTextArea = styled(TextField)({
  width: "100%",
  "& .MuiInputBase-root": {
    backgroundColor: "#ffffff",
  },
});

export const AddStampButton = styled(SecondaryActionButton)({
  fontSize: "16px",
  width: "fit-content",
  padding: "8px 36px",
  borderRadius: "100px",
  backgroundColor: "#F1EEFF",
  whiteSpace: "nowrap",
});

export const MobileStampAccordionContainer = styled(Box)({
  marginTop: "16px",
});

export const StampAccordionTitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

export const StampAccordionTitle = styled(Typography)({
  fontWeight: "medium",
  color: "black",
  fontSize: "20px",
});

export const StampDeleteButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  marginTop: "16px",
});

export const StampTitleText = styled(Typography)<{
  hasStamp: boolean;
  isMobile: boolean;
}>(({ hasStamp, isMobile }) => ({
  fontWeight: 500,
  color: "black",
  fontSize: !hasStamp ? "20px" : isMobile ? "16px" : "24px",
}));

export const StampHeaderTitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flex: 1,
});

export const Form = styled("form")({
  display: "flex",
  flexDirection: "column",
  flex: 1,
});
